import { useState, useCallback } from 'react';
import { useAppContext } from 'context-providers';
import { AsyncTask, AsyncTaskState } from 'library/async';
import { CalculationInput, CalculationOutput } from '@insight2profit/api-connector/services/types';

interface PerformCalcParams {
  clientId: string;
  modelId: string;
  inputs: CalculationInput[];
}
export function useCalc() {
  const { insightApi } = useAppContext();
  const [performCalcTask, setPerformCalcTask] = useState<AsyncTask<CalculationOutput[]>>({
    taskState: AsyncTaskState.NOT_STARTED,
  });

  const performCalc = useCallback(
    async ({ clientId, modelId, inputs }: PerformCalcParams) => {
      setPerformCalcTask({
        taskState: AsyncTaskState.IN_PROGRESS,
      });

      return await insightApi
        .performModelCalculation(clientId, modelId, inputs)
        .then(result => {
          setPerformCalcTask({
            taskState: AsyncTaskState.COMPLETED,
            result,
          });
          return result;
        })
        .catch(error => {
          setPerformCalcTask({
            taskState: AsyncTaskState.ERRORED,
            error,
          });
          throw new Error(error);
        });
    },
    [setPerformCalcTask, insightApi]
  );

  return {
    performCalc,
    performCalcTask,
  };
}
